import { useManagement } from '../store'
import {
  getImpersonatorId,
  getUserId,
} from '../store/management/managementSelectors'

const FRONT_DEVS_IDS = [
  8614689, 1408, 7435594, 6970073, 8417501, 10276448, 10954696, 3635572,
]

export const FRONT_QAS_IDS = [14462740]

export const useIsImpersonatorAndSuperAdmin = () => {
  const impersonatorId = useManagement(getImpersonatorId)
  const userId = useManagement(getUserId)
  const effectiveUserId = impersonatorId ?? userId

  return {
    isEngineer: effectiveUserId
      ? FRONT_DEVS_IDS.includes(effectiveUserId)
      : false,
    isQa: effectiveUserId ? FRONT_QAS_IDS.includes(effectiveUserId) : false,
  }
}
